import Actions from './user-actions';
import Model from './user-model';
import reducer from './user-reducer';
import Selectors from './user-selectors';
import sagas from './user-sagas';

export default {
  Actions,
  Api:       undefined,
  Model,
  namespace: 'user',
  reducer,
  sagas:     [sagas],
  Selectors,
};
